import { useState, useEffect, useMemo } from 'react';

import GenericDropdown from './GenericDropdown';
import Label from './form/Label';

const GenericTextBox = ({
    defaultValue,
    label,
    labelComponent,
    tooltip,
    autoComplete,
    css = {},
    onChange,
    onBlur,
    buttonTooltip = false,
    isRequired = false,
    innerRef,
    ...props
}) => {
    const [currentValue, setCurrentValue] = useState(defaultValue);

    useEffect(() => {
        setCurrentValue(defaultValue);
    }, [defaultValue]);

    const autoCompleteDropdown = useMemo(() => {
        if (autoComplete) {
            return (
                <GenericDropdown
                    toggleVariant='primary'
                    {...autoComplete}
                    onSelect={(value) => {
                        if (autoComplete.onSelect) {
                            autoComplete.onSelect(currentValue, value);
                        }
                    }}
                />
            );
        }

        return null;
    }, [autoComplete, currentValue]);

    const input = useMemo(() => {
        const inputEl = (
            <input
                className={`form-control ${css.input || ''}`}
                ref={innerRef}
                {...props}
                value={currentValue}
                onChange={(event) => {
                    setCurrentValue(event.target.value);

                    if (onChange) {
                        onChange(event);
                    }
                }}
                onBlur={(event) => {
                    if (onBlur && !props.readOnly) {
                        onBlur(event);
                    }
                }}
            />
        );

        if (autoCompleteDropdown) {
            return (
                <div className='d-flex'>
                    {inputEl}
                    {autoCompleteDropdown}
                </div>
            );
        }

        return inputEl;
    }, [currentValue, onChange, onBlur, props, innerRef, autoCompleteDropdown, css.input]);

    return (
        <>
            <Label
                controlId={props.id || props.name}
                label={label}
                labelComponent={labelComponent}
                tooltip={tooltip}
                buttonTooltip={buttonTooltip}
                isRequired={isRequired}
            />
            {input}
        </>
    );
};

export default GenericTextBox;
